module.exports = __webpack_public_path__ + "img/AR.51c7aeb1.svg";